var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pot-slide-item"},[_vm._t("default",[_c('a',{attrs:{"href":_vm.item.url}},[_c('img',{attrs:{"src":_vm.item.image}})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }